import { SET_CURRENT_POSTING } from '../constants'

export const setCurrentPosting = payload => async dispatch => {
  return dispatch({
    type: SET_CURRENT_POSTING,
    payload
  })
}
